interface Package {
  metadata: {
    credit_amount: number
    package_type: string
  }
}

export const getPackageDisplayName = (pkg: Package) => {
  const credits = pkg.metadata?.credit_amount || 0
  const packageType = pkg.metadata?.package_type || 'Unknown'

  return `${credits.toLocaleString()} Credits`
}
